import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FirmaStateService } from 'src/app/core/states/firma/firma-state.service';
import { PlantillasService } from 'src/app/core/services/plantilla.service';
import { BatchConfigurationPlantillaComponent } from 'src/app/shared/components/batch-configuration-plantilla/batch-configuration-plantilla.component';
import { SubidaDocumentoPlantillaComponent } from '../../subida-documento-plantilla/subida-documento-plantilla';
import Swal, { SweetAlertIcon } from 'sweetalert2';

@Component({
    selector: 'app-plantilla-component',
    templateUrl: './plantilla.component.html',
    styleUrls: ['./plantilla.css'],
})
export class PlantillasComponent implements OnInit {
    @ViewChild(SubidaDocumentoPlantillaComponent) subidaDocumentoPlantillaComponent!: SubidaDocumentoPlantillaComponent;
    @ViewChild(BatchConfigurationPlantillaComponent) BatchConfigurationPlantillaComponent!: BatchConfigurationPlantillaComponent;
    private destroy$ = new Subject<void>(); // Usado para desuscribir los Observables al destruir el componente
    plantillaForm: FormGroup;
    returAddPlantilla: any;
    stepActual = 0;
    idPlantilla: number;
    public titulo: string = '';
    public animationArray = ['/assets/lottie/add.json', '/assets/lottie/uploading2.json', '/assets/lottie/edit-icon.json']
    // Toast
    toast = Swal;
    resolverStepInicial = true;
    resolucionInicialActiva = true;

    constructor(
        private firmaStateService: FirmaStateService,
        private plantillaService: PlantillasService,
        private router: Router,
        private route: ActivatedRoute,
        private fb: FormBuilder,
    ) {

    }


    ngOnInit() {
        this.toastAlert();

        this.route.paramMap
            .pipe(takeUntil(this.destroy$)) // Desuscribe automáticamente al destruir el componente
            .subscribe(async params => {
                
                const id = params.get('id');
                if (Number(id)) {
                    this.titulo = 'Editar plantilla';
                } else {

                    this.titulo = 'Crear plantilla';
                }
            });
    }

    redirectStep(step: number) {
        this.stepActual = step;
    }

    async onStepChange(nuevoPaso: number) {

        this.resolucionInicialActiva = false;

        this.stepActual = nuevoPaso;

        let canAdvance = false;

        switch (this.stepActual) {

            case 0:
                if (this.BatchConfigurationPlantillaComponent) {
                    canAdvance =
                        await this.BatchConfigurationPlantillaComponent.addPlantilla();
                }
                break;

            case 1:
                if (this.subidaDocumentoPlantillaComponent) {
                    canAdvance =
                        await this.subidaDocumentoPlantillaComponent.validCantidadDocumentos();

                    if (!canAdvance) {
                        this.alert(
                            'warning',
                            'Documento requerido',
                            'Debe adjuntar al menos un documento antes de pasar a la siguiente etapa'
                        );
                    }
                }
                break;
        }

        if (canAdvance) {
            this.stepActual++;
        }
    }


    dataPlantilla(data: any) {
        this.returAddPlantilla = data;
    }

    rederict() {
        this.router.navigate(['/firmas/admin-plantillas']);
    }

    toastAlert() {
        this.toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 3000,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.onmouseenter = Swal.stopTimer;
                toast.onmouseleave = Swal.resumeTimer;
            }
        });
    }

    alert(icontext: SweetAlertIcon, title: string, text: string = '') {
        this.toast.fire({
            icon: icontext,
            title: title,
            text: text
        });
    }

}
